import { TrialCtaButton } from './TrialCtaButton';

export function DemoBanner() {
  return (
    <div style={containerStyle}>
      <span style={leftStyle}>
        <span style={dotStyle} aria-hidden />
        <strong style={{ color: '#ffffff', fontWeight: 600 }}>Canlı demo</strong>
      </span>
      <TrialCtaButton variant="link" source="banner" />
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 16,
  padding: '7px 20px',
  background: '#0f172a',
  color: '#ffffff',
  fontSize: 12,
  lineHeight: 1.4,
  flexShrink: 0,
  borderBottom: '1px solid rgba(255,255,255,0.08)',
};

const leftStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  minWidth: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};

const dotStyle: React.CSSProperties = {
  width: 7,
  height: 7,
  borderRadius: '50%',
  background: '#16a34a',
  boxShadow: '0 0 0 3px rgba(22,163,74,0.2)',
  flexShrink: 0,
};
